import { useState, useEffect, useCallback } from 'react';

export function useAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUser = useCallback(async () => {
        try {
            setLoading(true);
            const res = await fetch('/api/me');
            if (!res.ok) {
                setUser(null);
                setError(null);
            } else {
                const data = await res.json();
                setUser(data.user || null);
            }
        } catch (err) {
            console.error('Error fetching user:', err);
            setError(err);
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return {
        user,
        loading,
        error,
        refresh: fetchUser, //call this again manually to re-check login
        isLoggedIn: !!user,
    };
}
